import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination } from 'swiper/modules';
import './hero.css'
import b3 from './banner-3.jpg'
import b4 from './banner-4.jpg'
import b5 from './banner-5.jpg'

import b1 from './banner1.webp'
import b2 from './banner2.webp'

function Hero() {
    const bannerImage = [
        {
            id:1,
            img : b1
        },
        {
            id:2,
            img : b2
        },
        {
            id:3,
            img : b4  
        }
    ]
  return (
    <>
        <Swiper
        slidesPerView={1}
        spaceBetween={30}
        loop={true}
        pagination={{
          clickable: true,
        }}
        // navigation={true}
        modules={[Pagination]}
        className="mySwiper"
      >
        {
            bannerImage && bannerImage.map((item,index)=>(
                <SwiperSlide key={index}><img className='bannerImage' src={item.img} alt='' /></SwiperSlide>
            ))
        }
      </Swiper> 
    </>
  )
}

export default Hero
